module.exports = __webpack_public_path__ + "static/assets/f0162f213bfedc30557803936e40d928.png";